import { render, staticRenderFns } from "./AttachmentsUpload.vue?vue&type=template&id=1289bfbc&"
import script from "./AttachmentsUpload.vue?vue&type=script&lang=js&"
export * from "./AttachmentsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports